import React from "react";
import BarraSupDent from "../../commons/BarraSupDent";
import Title from "../Login/Components/title/title";
import "../Payment/Payment.css";
import firebaseManager from "../../model/Firebase/FirebaseManager";
import PaypalCheckOutButton from "./Component/PaypelCheckOutButton";

class Payment extends React.Component {
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        ele.classList.add("available");
        setTimeout(() => {
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  constructor() {
    super();

    this.dataPayDent = this.dataPayDent.bind(this);
    this.state = {
      total: "",
      paymentSuccessly: false,
    };

    this.dataPayDent();
  }

  dataPayDent() {
    firebaseManager.dentInProgress(this.successDataPay, this.failDataPay);
  }

  successDataPay = (data) => {
    this.setState({
      total: data.price,
      paymentSuccessly: sessionStorage.getItem("paymentSuccessly"),
    });
  };

  failDataPay(error) {
    alert(error.message);
  }

  render() {
    return (
      <div>
        <BarraSupDent />
        <div className="container">
          <Title text2="We won't charge you until your dent repair is complete" />
          <div className="text-center mt-5">
            <PaypalCheckOutButton order={this.state.total} />
            <p className="mt-5 mb-5">
              In rare cases, the estimated cost and time can change due to
              damage not noticeable in the photographs. <br /> If not cancelled
              one hour prior, cancellation fee is $50.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Payment;
